module.exports = __webpack_public_path__ + "static/media/file_black.dc92b2d1.svg";